import { render, staticRenderFns } from "./choseCourseSchoolLntroduce.vue?vue&type=template&id=bb5faa4c&scoped=true&"
import script from "./choseCourseSchoolLntroduce.vue?vue&type=script&lang=js&"
export * from "./choseCourseSchoolLntroduce.vue?vue&type=script&lang=js&"
import style0 from "./choseCourseSchoolLntroduce.vue?vue&type=style&index=0&id=bb5faa4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5faa4c",
  null
  
)

export default component.exports